import React, { useContext, useEffect, useState } from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const Header = () => {
  const { user, logout } = useContext(AuthContext);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (isAdmin) return null; // dashboard has its own navigation

  return (
    <Navbar
      id="mainNav"
      expand="lg" 
      fixed="top" 
      className={scrolled ? 'navbar-scrolled' : ''}
    >
      <Container>
        <LinkContainer to="/">
          <Navbar.Brand className="fw-bold">Mike Williams</Navbar.Brand>
        </LinkContainer>
        <Navbar.Toggle aria-controls="navbarResponsive" />
        <Navbar.Collapse id="navbarResponsive">
          <Nav className="ms-auto">
            <LinkContainer to="/">
              <Nav.Link>Home</Nav.Link>
            </LinkContainer>
            <Nav.Link href="/#about">About</Nav.Link>
            <Nav.Link href="/#skills">Skills</Nav.Link>
            <Nav.Link href="/#experience">Experience</Nav.Link>
            <Nav.Link href="/#community">Community</Nav.Link>
            {/* Blog temporarily pulled (2026-07-29, job-search focus) */}
            {/* "What Am I Eating?" temporarily pulled (2026-07-17) pending a dinners-only view */}
            <Nav.Link href="/#contact">Contact</Nav.Link>
            {user && (
              <>
                <LinkContainer to="/admin">
                  <Nav.Link>Dashboard</Nav.Link>
                </LinkContainer>
                <Nav.Link onClick={logout}>Logout</Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
